import { Browser, EndSessionHandler, EndSessionRequest } from 'ionic-appauth';
import { AuthorizationServiceConfiguration, StringMap, BasicQueryStringUtils } from '@openid/appauth';
import { CustomAuthService } from './custom-auth.service';

export class KeyrockIonicEndSessionHandler implements EndSessionHandler {

    constructor(
        private browser: Browser,
        private utils = new BasicQueryStringUtils(),
        private auth: CustomAuthService,
    ) { }

    // eslint-disable-next-line max-len
    public async performEndSessionRequest(configuration: AuthorizationServiceConfiguration, request: EndSessionRequest): Promise<string | undefined> {
        const url = this.buildRequestUrl(configuration, request);
        return this.browser.showWindow(url, request.postLogoutRedirectURI);
    }

    private buildRequestUrl(configuration: AuthorizationServiceConfiguration, request: EndSessionRequest) {
        const requestMap: StringMap = {
            _method: 'DELETE',
            client_id: this.auth.envConfig$.getValue().auth_config.client_id,
            post_logout_redirect_uri: request.postLogoutRedirectURI,
            state: request.state,
        };

        const query = this.utils.stringify(requestMap);
        const baseUrl = configuration.endSessionEndpoint;
        const url = `${baseUrl}?${query}`;
        return url;
    }
}
